export enum StartTimeType {
    NotBefore = "NotBefore",
    FollowedBy = "FollowedBy"
}